import { H2, H5 } from "../../../../AbstractElements";
import { FormGroup, Input, Label } from "reactstrap";
import { RegisterWizardForm } from "../../../../Type/Pages";
import { AgeWizard, BirthdayWizard, EnterYourEmailPasswordToLoginWizard, HavePassport, SignUpToAccount } from "../../../../Constant";

const MessageForm = ({formValue,getUserData}:RegisterWizardForm) => {
  const {birthDate,age,passPort}=formValue

  return (
    <div id="step-3" className="content">
    <div className="wizard-title">
      <H2>{SignUpToAccount}</H2>
      <H5 className="text-muted mb-4">{EnterYourEmailPasswordToLoginWizard}</H5>
    </div>
    <div className="login-main">
      <div className="theme-form">
        <FormGroup className="mb-3">
          <Label htmlFor="exampleFormControlInput1" check>{BirthdayWizard}</Label>
          <Input onChange={getUserData} value={birthDate} type="date" name="birthDate"  />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label className="control-label" check>{AgeWizard}</Label>
          <Input onChange={getUserData} value={age} placeholder="Age" type="text" name="age"  />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label className="control-label" check>{HavePassport}</Label>
          <Input onChange={getUserData} value={passPort} placeholder="Yes/No" type="text" name="passPort" />
        </FormGroup>
      </div>
    </div>
  </div>
  )
};

export default MessageForm;
